import React, { useState, useEffect } from "react";
import { useNavigate } from "react-router-dom";
import { useTranslation } from "react-i18next";
import { Home } from "lucide-react";
import {
  NOT_FOUND_VARIANTS,
  NotFoundVariant,
} from "../constants/404_constants.js";

const NotFound404Page: React.FC = () => {
  const { t } = useTranslation("landing");
  const navigate = useNavigate();
  const [selectedVariant, setSelectedVariant] =
    useState<NotFoundVariant | null>(null);

  // Select a random variant on component mount
  useEffect(() => {
    const randomIndex = Math.floor(Math.random() * NOT_FOUND_VARIANTS.length);
    setSelectedVariant(NOT_FOUND_VARIANTS[randomIndex]);
  }, []);

  // Don't render until variant is selected
  if (!selectedVariant) {
    return null;
  }

  const variantKey = `v${selectedVariant.id}` as "v1" | "v2" | "v3";

  return (
    <div className="min-h-screen min-w-screen bg-white flex justify-center px-4 py-8">
      <div className="bg-white rounded-xl p-8 md:p-12 text-center">
        {/* Title */}
        <div className="container mx-auto max-w-4xl">
          <div className="text-center mb-8">
            <h1 className="text-2xl md:text-4xl font-bold text-main-purple mb-2">
              {t("notFound.title")}
            </h1>
            <h2 className="text-lg md:text-2xl text-my-black mb-8 font-medium">
              {t("notFound.subtitle")}
            </h2>
          </div>

          {/* Image */}
          <div className="mb-8 flex justify-center">
            <img
              src={selectedVariant.image}
              alt={t(`notFound.variants.${variantKey}.altText`)}
              className="min-w-full h-auto min-h-52 md:min-h-32 object-cover"
            />
          </div>

          {/* Message */}
          <p className="text-xl md:text-2xl text-my-black mb-8 font-medium">
            {t(`notFound.variants.${variantKey}.message`)}
          </p>

          {/* Button */}
          <button
            onClick={() => navigate("/")}
            className="inline-flex items-center space-x-3 bg-main-purple hover:bg-lighter-blue text-white px-8 py-4 rounded-xl font-bold transition-all duration-300 hover:scale-105 shadow-lg"
          >
            <span className="md:hidden">
              <Home size={20} />
            </span>
            <span className="hidden md:inline">
              <Home size={24} />
            </span>
            <span className="md:text-lg font-medium">
              {" "}
              <span>
                <span className="hidden md:inline">
                  {t("notFound.backHome")}
                </span>
                <span className="inline md:hidden">{t("notFound.home")}</span>
              </span>
            </span>
          </button>
        </div>
      </div>
    </div>
  );
};

export default NotFound404Page;
